import { useState } from 'react';
import { startVoiceRecording as startVoiceRecognition, stopVoiceRecording } from '../helpers/voiceRecognition';

interface UseVoiceRecordingProps {
  onTranscript: (transcript: string) => void;
}

interface UseVoiceRecordingReturn {
  isRecording: boolean;
  startRecording: () => void;
  stopRecording: () => void;
}

/**
 * Custom hook for managing voice recording functionality
 *
 * @param {UseVoiceRecordingProps} props - Hook configuration
 * @param {Function} props.onTranscript - Callback function called with the transcript when recording completes
 * @return {UseVoiceRecordingReturn} Object containing recording state and control functions
 */
const useVoiceRecording = ({ onTranscript }: UseVoiceRecordingProps): UseVoiceRecordingReturn => {
  const [isRecording, setIsRecording] = useState(false);
  const [recognition, setRecognition] = useState<any>(null);

  const startRecording = () => {
    const recognitionInstance = startVoiceRecognition({
      onStart: () => {
        setIsRecording(true);
      },
      onResult: (transcript: string) => {
        onTranscript(transcript);
        setIsRecording(false);
      },
      onError: () => {
        setIsRecording(false);
      },
      onEnd: () => {
        setIsRecording(false);
      },
    });

    if (recognitionInstance) {
      setRecognition(recognitionInstance);
    }
  };

  const stopRecording = () => {
    stopVoiceRecording(recognition);
    setIsRecording(false);
  };

  return {
    isRecording,
    startRecording,
    stopRecording,
  };
};

export default useVoiceRecording;
